import { Row, Col, Modal, Tabs, Tab, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import AdminLinksComponent from "../../../components/admin/AdminLinksComponent";
import AdminSalesLinksComponent from "../../../components/admin/AdminSalesLinksComponent";
import { TableHeader, Pagination, Search } from "../../../components/DataTable";
import { useEffect, useState, useMemo } from "react";
import CartItemForOrderComponent from "../../../components/CartItemForOrderComponent";
import OrderItemForOrderPageComponent from "./OrderItemForOrderPageComponent";
import "./invoicePDF.css";
import * as FileSaver from "file-saver";
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import XLSX from "sheetjs-style";
//import { Tooltip } from '@mui/material';
import { useTrackEvents } from "../../trackEvents/useTrackEvents";
import { useDispatch, useSelector } from "react-redux";

const SalesOrdersPageComponent = ({ getOrders, getDeliveryBooks, getAllUsers, fetchCharts, updateDeliveryBook, updateUser }) => {
  const [orders, setOrders] = useState([]);
  const [deliveryBooks, setDeliveryBooks] = useState([])
  const [orderDeleted, setOrderDeleted] = useState(false);
  const [monthProfitMargin, setMonthProfitMargin] = useState(0)
  const { userInfo } = useSelector((state) => state.userRegisterLogin);
  const [filter, setFilter] = useState('month');
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [totalSales, setTotalSales] = useState(0);
  const [totalOrders, setTotalOrders] = useState(0);
  const [topSpendingCompany, setTopSpendingCompany] = useState(0)
  const [topSpendingAmount, setTopSpendingAmount] = useState(0)
  const [totalClients, setTotalClients] = useState(0)
  const [orderCompanies, setOrderCompanies] = useState([])
  const [topSellingProducts, setTopSellingProducts] = useState([])
  const [extSalesUsers, setExtSalesUsers] = useState([])
  const [allUsers, setAllUsers] = useState([])
  const [salesSummaryArray, setSalesSummaryArray] = useState([])
  const [orderCreatedCustomersArray, setOrderCreatedCustomersArray] = useState([])
  const [ordersByCompaniesArray, setOrdersByCompaniesArray] = useState([])
  const [ordersBySales, setOrdersBySales] = useState([])
  const [extSalesOrders, setExtSalesOrders] = useState([])
  const [extSalesOrdersOwners, setExtSalesOrdersOwners] = useState([])
  const [extSalesOrdersCompanies, setExtSalesOrdersCompanies] = useState([])
  const [extSalesSummary, setExtSalesSummary] = useState([])
  const [extTopProducts, setExtTopProducts] = useState([])
  const [showFilteredOrders, setshowFilteredOrders] = useState(false)

  const [showFilteredCompanies, setShowFilteredCompanies] = useState(false)
  const [showFilteredRepresentatives, setShowFilteredRepresentatives] = useState(false)
  const [filterValue, setFilterValue] = useState("ALL COMPANIES");
  const [search, setSearch] = useState("");
  const [companyFilterValue, setCompanyFilterValue] = useState("ALL REPRESENTATIVES");
  const [companySearch, setCompanySearch] = useState("");
  const [statusUpdate, setStatusUpdate] = useState(false)
  const [refresh, setRefresh] = useState(false)
  /* sort table */
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [sorting, setSorting] = useState({ field: "company", order: "desc" });
  const ITEMS_PER_PAGE = 40;

  const columnWidths = [
    "5%",
    "10%",
    "20%",
    "20%",
    "10%",
    "5%",
    "10%",
    "10%",
    "10%",
  ];
  const headers = [
    { name: "No#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Company", field: "userCompany", sortable: true },
    { name: "Delivery Site", field: "deliverySite", sortable: true },
    { name: "Total Amount", field: "orderTotal.cartSubtotal", sortable: true },
    { name: "Items", field: "items", sortable: true },
    { name: "PO#", field: "purchaseNumber", sortable: true },
    { name: "Invoice#", field: "invoiceNumber", sortable: true },
    { name: "Order Date", field: "createdAt", sortable: true },
  ];
  const salesColumnWidths = [
    "5%",
    "10%",
    "20%",
    "20%",
    "5%",
    "10%",
    "10%",
    "10%",
  ];
  const salesHeaders = [
    { name: "No#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Company", field: "userCompany", sortable: true },
    { name: "Delivery Site", field: "deliverySite", sortable: true },
    { name: "Items", field: "items", sortable: true },
    { name: "PO#", field: "purchaseNumber", sortable: true },
    { name: "Invoice#", field: "invoiceNumber", sortable: true },
    { name: "Order Date", field: "createdAt", sortable: true },
  ];

  const topProductsColumnWidths = [
    "10%",
    "40%",
    "40%",
  ];
  const topProductsHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Product Name", field: "name", sortable: false },
    { name: "Total Items Sold", field: "suppliedQty", sortable: false },
  ];

  const representativeColumnWidths = [
    "5%",
    "20%",
    "20%",
    "20%",
    "35%"
  ];
  const representativeHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Representative Name", field: "name", sortable: false },
    { name: "Total Orders Generated", field: "suppliedQty", sortable: false },
    { name: "Total Sales Generated", field: "suppliedQty", sortable: false },
    { name: "Companies Signed", field: "companies", sortable: false },
  ];

  const customersColumnWidths = [
    "2%",
    "10%",
    "10%",
    "10%",
    "6%",
    "6%",
    "6%",
    "10%"
  ];
  const customersHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Company", field: "company", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Phone", field: "mobileNumber", sortable: true },
    { name: "Total Orders", field: "totalOrdersCreated", sortable: true },
    { name: "Total Sales", field: "totalSalesGenerated", sortable: true },
    { name: "Activity", field: "activity", sortable: true }
  ];
  const salesCustomersColumnWidths = [
    "2%",
    "10%",
    "10%",
    "10%",
    "6%",
    "6%",
    // "6%",
    "10%"
  ];
  const salesCustomersHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Name", field: "name", sortable: true },
    { name: "Company", field: "company", sortable: true },
    { name: "Email", field: "email", sortable: true },
    { name: "Phone", field: "mobileNumber", sortable: true },
    { name: "Total Orders", field: "totalOrdersCreated", sortable: true },
    // { name: "Total Sales", field: "totalSalesGenerated", sortable: true },
    { name: "Activity", field: "activity", sortable: true }
  ];

  const companiesColumnWidths = [
    "2%",
    "18%",
    "10%",
    "8%",
    "8%",
    "10%",
    "40%"
  ];
  const companiesHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Company Name", field: "company", sortable: false },
    { name: "Signed By", field: "signedBy", sortable: false },
    { name: "Total Users", field: "totalUsers", sortable: false },
    { name: "Total Orders", field: "totalOrders", sortable: false },
    { name: "Total Sales", field: "totalSales", sortable: false },
    { name: "Action", field: "action", sortable: false },
  ];
  const salesCompaniesColumnWidths = [
    "2%",
    "20%",
    "12%",
    "12%",
    "12%",
    "40%"
  ];
  const salesCompaniesHeaders = [
    { name: "#", field: "index", sortable: false },
    { name: "Company Name", field: "company", sortable: false },
    { name: "Total Users", field: "totalUsers", sortable: false },
    { name: "Total Orders", field: "totalOrders", sortable: false },
    { name: "Total Sales", field: "totalSales", sortable: false },
    { name: "Action", field: "action", sortable: false },
  ];

  useEffect(() => {
    getOrders()
      .then((orders) => {
        setOrders(orders);

        // Extract and log company names
        const uniqueCompanies = [...new Set(orders.map(order => order.userCompany))];
        setOrderCompanies(uniqueCompanies)
      })
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.response?.data || er.message
        )
      );
  }, [orderDeleted, refresh]);

  useEffect(() => {
    getDeliveryBooks()
      .then((newData) => {
        setDeliveryBooks((prevData) => {
          const sameData = JSON.stringify(prevData) === JSON.stringify(newData);
          return sameData ? prevData : newData;
        });
      })
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.response?.data || er.message
        )
      );
    setStatusUpdate(false)
    setRefresh(false)
  }, [statusUpdate, refresh]);

  useEffect(() => {
    getAllUsers()
      .then((newData) => {
        setAllUsers((prevData) => {
          const sameData = JSON.stringify(prevData) === JSON.stringify(newData);
          return sameData ? prevData : newData;
        })
      })
      .catch((er) =>
        console.log(
          er.response?.data?.message || er.response?.data || er.message
        )
      );
  }, [statusUpdate, refresh])

  useEffect(() => {
    const signedByEmails = deliveryBooks
      .map(entry => entry.signedBy?.toLowerCase())
      .filter(email => email); // filters out falsy values

    const matchedUsers = allUsers.filter(user =>
      signedByEmails.includes(user.email?.toLowerCase())
    );
    setExtSalesUsers(matchedUsers)
  }, [deliveryBooks, allUsers])

  //REPRESENTATIVE PAGE
  useEffect(() => {
    if (!userInfo?.isExtSales) return;

    const signedCompanies = deliveryBooks
      .filter(book => book.signedBy === userInfo.email)
      .map(book => book.companyName);

    const filteredUsers = allUsers?.filter(user =>
      signedCompanies?.includes(user?.company)
    );

    const orderCreatedCustomers = filteredUsers?.map(user => {

      const userOrders = orders?.filter(order => order?.user?.email === user?.email);
      const totalOrders = userOrders?.length || 0;
      const totalSales = userOrders?.reduce((sum, order) => sum + (order.orderTotal?.cartSubtotal || 0), 0);

      setExtSalesOrders(prevOrders => {
        const existingIds = new Set(prevOrders.map(order => order._id));
        const newUniqueOrders = userOrders.filter(order => !existingIds.has(order._id));
        return [...prevOrders, ...newUniqueOrders];
      });

      return {
        name: user.name + " " + user.lastName,
        email: user.email,
        mobileNumber: user.mobile,
        company: user.company,
        followUp: user.followUp,
        totalOrdersCreated: totalOrders,
        totalSalesGenerated: totalSales
      };
    });
    setExtSalesOrdersOwners(orderCreatedCustomers);

    const companyStats = {};
    orderCreatedCustomers?.forEach(customer => {
      if (!customer.company) return;
      if (!companyStats[customer.company]) {
        companyStats[customer.company] = {
          company: customer.company,
          followUp: customer.followUp,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: 0
        };
      }
      companyStats[customer.company].totalOrders += customer.totalOrdersCreated;
      companyStats[customer.company].totalSales += customer.totalSalesGenerated;
    });

    //Count users per company from filteredUsers
    filteredUsers?.forEach(user => {
      const company = user.company;
      const followUp = user.followUp;
      if (!company) return;

      if (!companyStats[company]) {
        companyStats[company] = {
          company,
          followUp,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: 0
        };
      }
      companyStats[company].totalUsers += 1;
    });

    //Add any missing signed companies
    signedCompanies.forEach(company => {
      if (!companyStats[company]) {
        companyStats[company] = {
          company,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: filteredUsers?.filter(user => user.company === company).length || 0
        };
      }
    });

    const companyStatsArray = Object.values(companyStats).sort((a, b) => b.totalSales - a.totalSales);
    setExtSalesOrdersCompanies(companyStatsArray);

    const salesSummaryMap = {
      [userInfo.email]: {
        salesUser: `${userInfo.name} ${userInfo.lastName}`,
        email: userInfo.email,
        totalOrders: 0,
        totalSales: 0,
        companiesSigned: new Set(signedCompanies),
      }
    };

    orders?.forEach(order => {
      if (signedCompanies.includes(order.userCompany)) {
        const cartSubtotal = order.orderTotal?.cartSubtotal || 0;
        salesSummaryMap[userInfo.email].totalOrders += 1;
        salesSummaryMap[userInfo.email].totalSales += cartSubtotal;
      }
    });

    const salesSummaryArray = Object.values(salesSummaryMap).map(summary => ({
      ...summary,
      companiesSigned: Array.from(summary.companiesSigned)
    }));
    setExtSalesSummary(salesSummaryArray);
  }, [orders, deliveryBooks, allUsers, userInfo]);


  //SUPER ADMIN PAGE
  useEffect(() => {
    const extSalesEmails = extSalesUsers?.map(user => user.email);
    const signedCompanies = deliveryBooks
      .filter(book => extSalesEmails?.includes(book.signedBy))
      .map(book => book.companyName);

    const filteredUsers = allUsers?.filter(user =>
      signedCompanies.includes(user.company)
    );

    const orderCreatedCustomers = filteredUsers?.map(user => {
      const userOrders = orders?.filter(order => order?.user?.email === user?.email);
      const totalOrders = userOrders?.length || 0;
      const totalSales = userOrders?.reduce((sum, order) => sum + (order.orderTotal?.cartSubtotal || 0), 0);

      return {
        name: user.name + " " + user.lastName,
        email: user.email,
        mobileNumber: user.mobile,
        company: user.company,
        followUp: user.followUp,
        totalOrdersCreated: totalOrders,
        totalSalesGenerated: totalSales,
        id: user._id,
        contacted: user.contacted,
        contactedDate: user.contactedDate
      };
    });
    setOrderCreatedCustomersArray(orderCreatedCustomers);

    // Build company-to-signedBy map from deliveryBooks
    const companyToSignedByMap = {};
    deliveryBooks.forEach(book => {
      if (book.companyName && book.signedBy) {
        const user = allUsers?.find(u => u.email === book.signedBy);
        const fullName = user ? `${user.name} ${user.lastName}` : book.signedBy;
        companyToSignedByMap[book.companyName] = fullName;
      }
    });

    const companyStats = {};
    orderCreatedCustomers?.forEach(customer => {
      if (!customer?.company) return;
      if (!companyStats[customer.company]) {
        companyStats[customer.company] = {
          company: customer.company,
          signedBy: companyToSignedByMap[customer.company] || null,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: 0
        };
      }
      companyStats[customer.company].totalOrders += customer.totalOrdersCreated;
      companyStats[customer.company].totalSales += customer.totalSalesGenerated;
    });

    //Count users per company from filteredUsers
    filteredUsers?.forEach(user => {
      const company = user.company;
      if (!company) return;

      if (!companyStats[company]) {
        companyStats[company] = {
          company,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: 0
        };
      }
      companyStats[company].totalUsers += 1;
    });

    const companyStatsArray = Object.values(companyStats);
    // Ensure all signedCompanies are represented
    signedCompanies.forEach(company => {
      const exists = companyStatsArray.some(stat => stat.company === company);
      if (!exists) {
        companyStatsArray.push({
          company,
          signedBy: companyToSignedByMap[company] || null,
          totalOrders: 0,
          totalSales: 0,
          totalUsers: filteredUsers?.filter(user => user.company === company).length || 0
        });
      }
    });

    // Optional: sort after adding missing companies
    companyStatsArray.sort((a, b) => b.totalSales - a.totalSales);
    setOrdersByCompaniesArray(companyStatsArray);

    const emailToNameMap = {};
    extSalesUsers.forEach(user => {
      emailToNameMap[user.email] = user.name && user.lastName
        ? `${user.name} ${user.lastName}`
        : user.name || user.email;
    });

    const salesRepCompanies = {};
    deliveryBooks.forEach(book => {
      if (extSalesEmails.includes(book.signedBy)) {
        if (!salesRepCompanies[book.signedBy]) {
          salesRepCompanies[book.signedBy] = new Set();
        }
        salesRepCompanies[book.signedBy].add(book.companyName);
      }
    });

    const companyToRep = {};
    Object.entries(salesRepCompanies).forEach(([signedBy, companies]) => {
      companies.forEach(companyName => {
        companyToRep[companyName] = signedBy;
      });
    });

    const salesSummaryMap = {};
    signedCompanies.forEach(companyName => {
      const repEmail = companyToRep[companyName];
      if (!repEmail) return;

      if (!salesSummaryMap[repEmail]) {
        salesSummaryMap[repEmail] = {
          salesUser: emailToNameMap[repEmail],
          email: repEmail,
          totalOrders: 0,
          totalSales: 0,
          companiesSigned: new Set()
        };
      }
      salesSummaryMap[repEmail].companiesSigned.add(companyName);
    });

    orders?.forEach(order => {
      const companyName = order.userCompany;
      const repEmail = companyToRep[companyName];
      if (!repEmail) return;
      const cartSubtotal = order.orderTotal?.cartSubtotal || 0;

      if (!salesSummaryMap[repEmail]) return;
      const summary = salesSummaryMap[repEmail];
      summary.totalOrders += 1;
      summary.totalSales += cartSubtotal;
    });

    const salesSummaryArray = Object.values(salesSummaryMap).map(user => ({
      salesUser: user.salesUser,
      email: user.email,
      totalOrders: user.totalOrders,
      totalSales: user.totalSales,
      companiesSigned: Array.from(user.companiesSigned)
    }));

    const existingEmails = new Set(salesSummaryArray.map(user => user.email));
    extSalesUsers?.forEach(user => {
      if (!existingEmails.has(user.email)) {
        salesSummaryArray.push({
          salesUser: `${user.name} ${user.lastName}`,
          email: user.email,
          totalOrders: 0,
          totalSales: 0,
          companiesSigned: []
        });
      }
    });

    setSalesSummaryArray(salesSummaryArray);
  }, [orders, deliveryBooks, extSalesUsers, allUsers]);

  //sorting
  useEffect(() => {
    const getNestedProperty = (obj, path) => {
      return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    };

    if (sorting.field) {
      let computedOrders = userInfo.isExtSales ? extSalesOrdersOwners : orderCreatedCustomersArray
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedOrders = computedOrders.sort((a, b) => {
        const fieldA = getNestedProperty(a, sorting.field);
        const fieldB = getNestedProperty(b, sorting.field);

        if (typeof fieldA === "number" && typeof fieldB === "number") {
          return reversed * (fieldA - fieldB);
        } else if (typeof fieldA === "string" && typeof fieldB === "string") {
          return reversed * fieldA.localeCompare(fieldB);
        } else {
          // If field types are different, compare their string representations
          return reversed * String(fieldA).localeCompare(String(fieldB));
        }
      });
      userInfo.isExtSales ? setExtSalesOrdersOwners(computedOrders) : setOrderCreatedCustomersArray(computedOrders)
    }
  }, [sorting])

  //To get total sales, total orders,
  useEffect(() => {
    const now = new Date();
    const todayDate = now.getDate();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();
    const firstDayOfWeek = new Date(now);
    firstDayOfWeek.setDate(now.getDate() - now.getDay());
    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    const filtered = (userInfo?.isExtSales ? extSalesOrders : orders).filter(order => {
      const orderDate = new Date(order.createdAt);
      switch (filter) {
        case 'day':
          return (
            orderDate.getDate() === todayDate &&
            orderDate.getMonth() === thisMonth &&
            orderDate.getFullYear() === thisYear
          );
        case 'week':
          return (
            orderDate >= firstDayOfWeek && orderDate <= lastDayOfWeek
          );
        case 'month':
          return (
            orderDate.getMonth() === thisMonth &&
            orderDate.getFullYear() === thisYear
          );
        case 'year':
          return orderDate.getFullYear() === thisYear;
        case 'all':
        default:
          return true;
      }
    });

    const total = filtered.reduce(
      (sum, order) => sum + (order.orderTotal?.cartSubtotal || 0),
      0
    );

    // Company spending logic
    const companyTotals = {};
    filtered.forEach(order => {
      const company = order.userCompany || 'Unknown';
      const amount = order.orderTotal?.cartSubtotal || 0;
      companyTotals[company] = (companyTotals[company] || 0) + amount;
    });

    let topSpender = null;
    let topSpenderAmount = 0;

    for (const company in companyTotals) {
      if (companyTotals[company] > topSpenderAmount) {
        topSpender = company;
        topSpenderAmount = companyTotals[company];
      }
    }

    setFilteredOrders(filtered);
    setTotalSales(total.toFixed(2));
    setTotalOrders(filtered.length);
    setTopSpendingCompany(topSpender);
    setTopSpendingAmount(topSpenderAmount.toFixed(2));
  }, [filter, orders, extSalesOrders]);

  //To get total clients
  useEffect(() => {
    const now = new Date();
    const todayDate = now.getDate();
    const thisMonth = now.getMonth();
    const thisYear = now.getFullYear();

    const firstDayOfWeek = new Date(now);
    firstDayOfWeek.setDate(now.getDate() - now.getDay());

    const lastDayOfWeek = new Date(firstDayOfWeek);
    lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

    const filteredDeliveryBooks =
      typeof userInfo.isExtSales !== 'undefined'
        ? deliveryBooks.filter(deliveryBook => deliveryBook.signedBy === userInfo.email)
        : [];


    const filtered = (typeof userInfo.isExtSales !== 'undefined'
      ? deliveryBooks.filter(deliveryBook => deliveryBook.signedBy === userInfo.email)
      : deliveryBooks).filter(book => {
        const clientCreatedAt = new Date(book.createdAt);
        switch (filter) {
          case 'day':
            return (
              clientCreatedAt.getDate() === todayDate &&
              clientCreatedAt.getMonth() === thisMonth &&
              clientCreatedAt.getFullYear() === thisYear
            );
          case 'week':
            return (
              clientCreatedAt >= firstDayOfWeek && clientCreatedAt <= lastDayOfWeek
            );
          case 'month':
            return (
              clientCreatedAt.getMonth() === thisMonth &&
              clientCreatedAt.getFullYear() === thisYear
            );
          case 'year':
            return clientCreatedAt.getFullYear() === thisYear;
          case 'all':
          default:
            return true;
        }
      });
    setTotalClients(filtered.length);
  }, [filter, deliveryBooks]);

  //Top 10 products Super Admin Page
  useEffect(() => {
    const summary = {};
    orders.forEach(order => {
      order.cartItems?.forEach(item => {
        const name = item.name;
        const qty = item.cartProducts?.[0]?.suppliedQty || 0;

        if (summary[name]) {
          summary[name] += qty;
        } else {
          summary[name] = qty;
        }
      });
    });
    // Convert summary to array and sort by suppliedQty in descending order
    const sortedResult = Object.entries(summary)
      .map(([name, suppliedQty]) => ({ name, suppliedQty }))
      .sort((a, b) => b.suppliedQty - a.suppliedQty)
      .slice(0, 10)
    //console.log(sortedResult);
    setTopSellingProducts(sortedResult)
  }, [orders]);

  //Top 10 products Repressentatives Page
  useEffect(() => {
    const summary = {};
    extSalesOrders.forEach(order => {
      order.cartItems?.forEach(item => {
        const name = item.name;
        const qty = item.cartProducts?.[0]?.suppliedQty || 0;

        if (summary[name]) {
          summary[name] += qty;
        } else {
          summary[name] = qty;
        }
      });
    });
    // Convert summary to array and sort by suppliedQty in descending order
    const sortedResult = Object.entries(summary)
      .map(([name, suppliedQty]) => ({ name, suppliedQty }))
      .sort((a, b) => b.suppliedQty - a.suppliedQty)
      .slice(0, 10)
    //console.log(sortedResult);
    setExtTopProducts(sortedResult)
  }, [extSalesOrders]);

  //CUSTOMERS FILTER AND SEARCH
  useEffect(() => {
    let filteredUsers = userInfo.isExtSales === true ? extSalesOrdersOwners : orderCreatedCustomersArray
    if (filterValue !== "ALL COMPANIES") {
      filteredUsers = filteredUsers.filter(
        (order) => order.company?.toUpperCase() === filterValue
      );
    }

    if (search) {
      filteredUsers = filteredUsers.filter(
        (order) =>
          order.company?.toUpperCase().includes(search.toUpperCase()) ||
          order.name?.toUpperCase().includes(search.toUpperCase()) ||
          order.email?.toUpperCase().includes(search.toUpperCase()) ||
          order.mobileNumber?.toUpperCase().includes(search.toUpperCase())
      );
    }
    setShowFilteredCompanies(filteredUsers);

  }, [filterValue, extSalesOrdersOwners, orderCreatedCustomersArray, userInfo, search])

  //COMPANIES FILTER AND SEARCH
  useEffect(() => {
    let filteredUsers = userInfo.isExtSales === true ? extSalesOrdersCompanies : ordersByCompaniesArray
    if (companyFilterValue !== "ALL REPRESENTATIVES") {
      filteredUsers = filteredUsers.filter(
        (user) => user.signedBy?.toUpperCase() === companyFilterValue?.toUpperCase()
      );
    }

    if (companySearch) {
      filteredUsers = filteredUsers.filter(
        (user) =>
          user.company?.toUpperCase().includes(companySearch.toUpperCase()) ||
          user.signedBy?.toUpperCase().includes(companySearch.toUpperCase())
      );
    }
    setShowFilteredRepresentatives(filteredUsers);
  }, [companyFilterValue, extSalesOrdersCompanies, ordersByCompaniesArray, userInfo, companySearch])
  // console.log(extSalesOrdersCompanies , ordersByCompaniesArray);

  //Tracking user Interactions
  //useTrackEvents();
  // var trackData = localStorage.getItem("trackData")
  //console.log("trackData", trackData);

  //CHART SECTION//
  // const [chart, setChart] = useState();
  // const [charts, setCharts] = useState();
  // const [selectedUrl, setSelectedUrl] = useState("");
  // const [selectedId, setSelectedId] = useState("")

  // useEffect(() => {
  //   fetchCharts()
  //     .then((data) => {
  //       setCharts(data);
  //     })
  //     .catch((er) =>
  //       console.log(
  //         er.response.data.message ? er.response.data.message : er.response.data
  //       ));
  // }, [0]);

  // useEffect(() => {
  //   setSelectedUrl(charts ? charts[0]?.baseUrl : "")
  //   setSelectedId(charts ? charts[0]?.chartId : "")
  //   charts?.map((char) => {
  //     if (char?.name === "Monthly Sales") {
  //       setSelectedUrl(char.baseUrl)
  //       setSelectedId(char.chartId)
  //     }
  //   }
  //   )
  // }, [charts])

  // useEffect(() => {
  //   if (selectedUrl !== "" && selectedId !== "") {
  //     const sdk = new ChartsEmbedSDK({ baseUrl: selectedUrl })
  //     setChart(sdk.createChart({
  //       chartId: selectedId,
  //       height: "650px",
  //       width: "100%",
  //       showAttribution: false
  //     }))
  //   }

  // }, [selectedId])

  // useEffect(() => {
  //   renderChart();
  // }, [chart])

  // async function renderChart() {
  //   await chart.render(document.getElementById("chart"));

  // }
  // order items Modal and Back Order
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setShowCustomerModal(false)
    setShowCompanyModal(false)
  };
  const handleShow = (orderId) => {
    setSelectedOrderId(orderId);
    setShow(true);
  };

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const getOrderStyle = (order) => ({
    cursor: "pointer",
    color: order.backOrder ? "red" : "black",
    fontWeight: order.backOrder ? "bold" : "normal",
  });

  //Purchased products list.
  var orderProductsList = [];
  orders.map((order) => {
    order.cartItems.map((item) => { });
  });

  //Export to Excel
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const fileName = "Order_products";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(orderProductsList);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  const [openRowIndex, setOpenRowIndex] = useState(null);
  const loadRepOrders = (companies, idx) => {
    if (openRowIndex === idx) {
      // Row is already open → hide it
      setOpenRowIndex(null);
      setOrdersBySales([]);
    } else {
      // Open new row
      const filteredOrders = orders?.filter(order =>
        companies?.includes(order.userCompany)
      );
      setOrdersBySales(filteredOrders);
      setOpenRowIndex(idx);
    }
  };

  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("");
  const [contactName, setContactName] = useState("");
  const [contactInfo, setContactInfo] = useState("");

  const handleActionClick = (label, company) => {
    setSelectedLabel(label);
    setSelectedCompany(company);
    setContactName("");
    setContactInfo("");
    setShowCompanyModal(true);
  };

  const handleCompanyModalSubmit = async () => {
    const dateNow = new Date().toISOString();
    try {
      const response = await updateDeliveryBook(
        selectedCompany,
        selectedLabel,     // e.g. "Email", "Call 1"
        dateNow,
        contactName,
        contactInfo
      );
      if (response) {
        setStatusUpdate(true);
        setShowCompanyModal(false);
      }
    } catch (error) {
      console.error("Failed to update delivery book status:", error);
    }
  };

  const [selectedUser, setSelectedUser] = useState("");
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [dateTime, setDateTime] = useState("")
  const today = new Date()

  const formatDateTimeLocal = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const handleCustomerActionClick = (label, user, date) => {
    setSelectedLabel(label);
    setSelectedUser(user);
    setShowCustomerModal(true)

    if (!date || date === "null" || date === "undefined") {
      setDateTime(formatDateTimeLocal(new Date()));
    } else {
      setDateTime(formatDateTimeLocal(date));
    }
  };

  const handleCustomerModelSubmit = async () => {
    try {
      const response = await updateUser(
        selectedUser,
        selectedLabel,
        dateTime,
      );

      if (response) {
        setStatusUpdate(true);
        setRefresh(!refresh)
        setShowCustomerModal(false)
      }
    } catch (error) {
      console.error("Failed to update user status:", error);
    }
  };
  // console.log(extSalesOrdersOwners, orderCreatedCustomersArray);

  return (
    <>
      <Row className="content-container m-5">
        <Col md={2}>
          <AdminLinksComponent />
        </Col>
        <Col md={10}>
          <div className="row mb-3" style={{ backgroundColor: "#D3D3D3" }}>
            <div className="mb-0 text-center">
              {['day', 'week', 'month', 'year', 'all'].map((type) => (
                <button
                  key={type}
                  className={`btn btn-sm m-1 ${filter === type ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => setFilter(type)}
                >
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </button>
              ))}
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Sales</h5>
                <p><b>${new Intl.NumberFormat('en-US').format(totalSales)}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Orders</h5>
                <p><b>{totalOrders}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Total Clients</h5>
                <p><b>{totalClients}</b></p>
              </div>
            </div>
            <div className="col-md-3" style={{ width: "25%", textAlign: "center" }}>
              <div className="card p-3 shadow-sm mt-1 mb-3">
                <h5>Top Client</h5>
                <p><b>{topSpendingCompany} (${new Intl.NumberFormat('en-US').format(topSpendingAmount)})</b></p>
              </div>
            </div>
          </div>
          <Tabs
            defaultActiveKey={"REPRESENTATIVES"}
            transition={false}
            id="noanim-tab-example"
            className="mb-3">
            <Tab eventKey="REPRESENTATIVES" title={userInfo?.isExtSales === true ? "MY SUMMARY" : "REPRESENTATIVES"}>
              <table className="table table-striped table-sm">
                <TableHeader
                  headers={representativeHeaders}
                  widths={representativeColumnWidths}
                />
                <tbody>
                  {(userInfo.isExtSales === true ? extSalesSummary : salesSummaryArray).map((user, idx) => (
                    <>
                      <tr key={idx}
                        onClick={() => loadRepOrders(user?.companiesSigned, idx)}
                        style={{ cursor: "pointer" }}>
                        <td className="no-wrap-td">{idx + 1}</td>
                        <td className="no-wrap-td">
                          {user.salesUser}
                        </td>
                        <td
                          className="no-wrap-td"
                        >
                          {user.totalOrders}
                        </td>
                        <td className="no-wrap-td">
                          {user.totalSales.toLocaleString("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          })}
                        </td>
                        <td className="no-wrap-td">
                          {user.companiesSigned.map((company, idx) => (
                            <div key={idx}>{company.toUpperCase()}</div>
                          ))}
                        </td>
                      </tr>
                      {openRowIndex === idx && ordersBySales.length > 0 && (
                        <tr style={{ backgroundColor: "lightBlue", border: "black" }}>
                          <td colSpan={5}>
                            <div style={{ height: "300px", overflow: "auto" }}>
                              <table className="table">
                                <TableHeader
                                  headers={userInfo?.isExtSales ? salesHeaders : headers}
                                  onSorting={(field, order) => setSorting({ field, order })}
                                  widths={userInfo?.isExtSales ? salesColumnWidths : columnWidths}
                                />
                                <tbody>
                                  {ordersBySales?.map((order, index) => (
                                    <tr key={index}>
                                      <td className="no-wrap-td">{index + 1}</td>
                                      <td
                                        onClick={() => handleShow(order._id)}
                                        style={getOrderStyle(order)}
                                        className="no-wrap-td"
                                      >
                                        {order.user ? `${order.user.name} ${order.user.lastName}` : null}
                                      </td>
                                      <td
                                        onClick={() => handleShow(order._id)}
                                        style={getOrderStyle(order)}
                                        className="no-wrap-td"
                                      >
                                        {order.userCompany}
                                      </td>
                                      <td
                                        onClick={() => handleShow(order._id)}
                                        style={getOrderStyle(order)}
                                        className="no-wrap-td"
                                      >
                                        {order.deliverySite.toUpperCase()}
                                      </td>
                                      {!userInfo?.isExtSales ? (
                                        <td className="no-wrap-td">
                                          {order.orderTotal.cartSubtotal.toLocaleString("en-AU", {
                                            style: "currency",
                                            currency: "AUD",
                                          })}
                                        </td>
                                      ) : ("")}
                                      <td
                                        onClick={() => handleShow(order._id)}
                                        style={getOrderStyle(order)}
                                        className="no-wrap-td"
                                      >
                                        {order.cartItems.length}
                                      </td>
                                      <td
                                        onClick={() => handleShow(order._id)}
                                        style={getOrderStyle(order)}
                                        className="no-wrap-td"
                                      >
                                        {order.purchaseNumber}
                                      </td>
                                      <td className="no-wrap-td">{order.invoiceNumber}</td>
                                      <td className="no-wrap-td">{order.createdAt.substring(0, 10)}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="CUSTOMERS" title="CUSTOMERS">
              <div className="row mb-1">
                <div className="col-md-5">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-3">

                </div>
                <div className="col-md-4 d-flex justify-content-between">
                  <select
                    value={filterValue}
                    onChange={(e) => setFilterValue(e.target.value)}
                    className="form-select me-3"
                  >
                    <option value="ALL COMPANIES">ALL COMPANIES</option>
                    {[...new Set((userInfo.isExtSales === true ? extSalesOrdersOwners : orderCreatedCustomersArray)?.map(user => user.company?.toUpperCase()))]
                      .sort()
                      .map(company => (
                        <option key={company} value={company}>
                          {company}
                        </option>
                      ))}
                  </select>
                  <Search
                    onSearch={(value) => {
                      setSearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <table className="table table-striped table-sm">
                <TableHeader
                  headers={userInfo?.isExtSales ? salesCustomersHeaders : customersHeaders}
                  widths={userInfo?.isExtSales ? salesCustomersColumnWidths : customersColumnWidths}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {((filterValue !== "ALL COMPANIES" || search !== "")
                    ? showFilteredCompanies
                    : (userInfo.isExtSales ? extSalesOrdersOwners : orderCreatedCustomersArray)
                  ).map((user, idx) => (
                    < tr key={idx} >
                      <td className="no-wrap-td">{idx + 1}</td>
                      <td className="no-wrap-td">
                        <a href={`/admin/edit-user/${user.id}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          {user.name}
                        </a>
                      </td>
                      <td className="no-wrap-td">
                        {user.company.toUpperCase()}
                      </td>
                      <td className="no-wrap-td">
                        {user.email}
                      </td>
                      <td className="no-wrap-td">
                        {user.mobileNumber}
                      </td>
                      <td
                        className="no-wrap-td"
                      >
                        {user.totalOrdersCreated}
                      </td>
                      {!userInfo.isExtSales ? (
                        <td className="no-wrap-td">
                          {user.totalSalesGenerated.toLocaleString("en-AU", {
                            style: "currency",
                            currency: "AUD",
                          })}
                        </td>
                      ) : ("")}
                      <td className="flex gap-2 flex-wrap">
                        {["Email-1", "Call-1", "Email-2", "Call-2"]
                          .map((label) => {
                            // const matchedUsers = allUsers.find(user => user.companyName === user.company);
                            const followUpMap = {
                              "Email-1": "email1",
                              "Call-1": "call1",
                              "Email-2": "email2",
                              "Call-2": "call2",
                            };
                            const key = followUpMap[label];
                            const isCompleted = user?.followUp?.[key]?.completed ? user?.followUp?.[key]?.completed : label === "Call-1" ? user.contacted : null
                            const date = user?.followUp?.[key]?.date
                              ? new Date(user.followUp[key].date)
                              : label === "Call-1" ? user?.contactedDate ? new Date(user?.contactedDate) : null : null;

                            return {
                              label,
                              isCompleted,
                              date,
                            };
                          })
                          //Sort completed items first, then by date (ascending), then incomplete
                          // .sort((a, b) => {
                          //   if (a.isCompleted && b.isCompleted) {
                          //     return (a.date || 0) - (b.date || 0);
                          //   }
                          //   if (a.isCompleted) return -1;
                          //   if (b.isCompleted) return 1;
                          //   return 0;
                          // })
                          .map(({ label, isCompleted, date }) => {
                            const tooltip = (
                              <Tooltip id={`tooltip-${label}`} style={{ width: '200px', height: '40px', overflow: 'none' }}>
                                {/* <div>{contactName?.toUpperCase()}</div>
                                <div>{contactInfo}</div> */}
                                <div>
                                  {date?.toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true  // 24-hour format
                                  })}
                                </div>
                              </Tooltip>
                            );

                            return (
                              <OverlayTrigger
                                placement="top"
                                overlay={isCompleted ? tooltip : <></>}
                              >
                                <button
                                  key={label}
                                  className="px-2 py-1 me-2 border rounded flex items-center gap-1"
                                  style={{
                                    backgroundColor: isCompleted ? 'gray' : 'green',
                                    color: 'white',
                                    width: "80px",
                                    opacity:
                                      user.signedBy !== undefined &&
                                        !user.signedBy?.includes(userInfo?.name) &&
                                        !isCompleted
                                        ? 0.5
                                        : 1
                                  }}
                                  onClick={() => handleCustomerActionClick(label, user, date)}
                                // disabled={
                                //   isCompleted ||
                                //   (user.signedBy !== undefined &&
                                //     !user.signedBy?.includes(userInfo?.name))
                                // }

                                >
                                  {label}
                                </button>
                              </OverlayTrigger>
                            )
                          })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="COMPANIES" title="COMPANIES">
              <div className="row mb-1">
                <div className="col-md-5">
                  <Pagination
                    total={totalItems}
                    itemsPerPage={ITEMS_PER_PAGE}
                    currentPage={currentPage}
                    onPageChange={(page) => setCurrentPage(page)}
                  />
                </div>
                <div className="col-md-3">
                  <Button
                    onClick={() => setRefresh(true)}>Refresh</Button>
                </div>
                {/* filter and search */}
                <div className="col-md-4 d-flex justify-content-between">
                  {
                    !userInfo?.isExtSales ? (
                      <select
                        value={companyFilterValue}
                        onChange={(e) => setCompanyFilterValue(e.target.value)}
                        className="form-select me-3"
                      >
                        <option value="ALL REPRESENTATIVES">ALL REPRESENTATIVES</option>
                        {[...new Set((userInfo.isExtSales === true ? extSalesOrdersCompanies : ordersByCompaniesArray)?.map(user => user.signedBy?.toUpperCase()))]
                          .sort()
                          .map(company => (
                            <option key={company} value={company}>
                              {company}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <div className=" me-3"></div>
                    )
                  }

                  <Search
                    onSearch={(value) => {
                      setCompanySearch(value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <table className="table table-striped table-sm">
                <TableHeader
                  headers={userInfo?.isExtSales ? salesCompaniesHeaders : companiesHeaders}
                  widths={userInfo?.isExtSales ? salesCompaniesColumnWidths : companiesColumnWidths}
                />
                <tbody>
                  {((companyFilterValue !== "ALL REPRESENTATIVES" || companySearch !== "")
                    ? showFilteredRepresentatives
                    : (userInfo.isExtSales ? extSalesOrdersCompanies : ordersByCompaniesArray)
                  ).map((user, idx) => (
                    <tr key={idx}
                      hidden={userInfo.isExtSales && user.totalSales > 5000 ? true : false}
                      style={{ backgroundColor: user?.totalSales > 4000 ? "#ccffcc" : (user.totalSales > 3000 ? "#ffd699" : user.totalSales > 2000 ? "#ffcccc" : "white") }}>
                      <td className="no-wrap-td">{idx + 1}</td>
                      <td className="no-wrap-td">
                        {user.company.toUpperCase()}
                      </td>
                      {!userInfo?.isExtSales ? (
                        <td className="no-wrap-td">
                          {user.signedBy}
                        </td>
                      ) : ("")}
                      <td
                        className="no-wrap-td"
                      >
                        {user.totalUsers}
                      </td>
                      <td
                        className="no-wrap-td"
                      >
                        {user.totalOrders}
                      </td>
                      <td className="no-wrap-td">
                        {user.totalSales?.toLocaleString("en-AU", {
                          style: "currency",
                          currency: "AUD",
                        })}
                      </td>

                      <td className="flex gap-2 flex-wrap">
                        {["Email", "Visit", "Call 1", "Call 2"]
                          .map((label) => {
                            const matchedBook = deliveryBooks.find(book => book.companyName === user.company);
                            const followUpMap = {
                              "Email": "email",
                              "Call 1": "call1",
                              "Call 2": "call2",
                              "Visit": "visit",
                            };

                            const key = followUpMap[label];
                            const isCompleted = matchedBook?.followUp?.[key]?.completed || false;
                            const contactName = matchedBook?.followUp?.[key]?.contactName || ""
                            const contactInfo = matchedBook?.followUp?.[key]?.contactInfo || ""
                            const date = matchedBook?.followUp?.[key]?.date
                              ? new Date(matchedBook.followUp[key].date)
                              : null;

                            return {
                              label,
                              isCompleted,
                              date,
                              contactName,
                              contactInfo
                            };
                          })
                          //Sort completed items first, then by date (ascending), then incomplete
                          .sort((a, b) => {
                            if (a.isCompleted && b.isCompleted) {
                              return (a.date || 0) - (b.date || 0);
                            }
                            if (a.isCompleted) return -1;
                            if (b.isCompleted) return 1;
                            return 0;
                          })
                          .map(({ label, isCompleted, date, contactName, contactInfo }) => {
                            const tooltip = (
                              <Tooltip id={`tooltip-${label}`} style={{ width: '200px', height: '90px', overflow: 'auto' }}>
                                <div>{contactName?.toUpperCase()}</div>
                                <div>{contactInfo}</div>
                                <div>
                                  {date?.toLocaleString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "2-digit",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true  // 24-hour format
                                  })}
                                </div>
                              </Tooltip>
                            );
                            return (
                              <OverlayTrigger
                                placement="top"
                                overlay={isCompleted ? tooltip : <></>}
                              >
                                <button
                                  key={label}
                                  className="px-2 py-1 me-2 border rounded flex items-center gap-1"
                                  style={{
                                    backgroundColor: isCompleted ? 'gray' : 'green',
                                    color: 'white',
                                    width: "140px",
                                    opacity:
                                      user.signedBy !== undefined &&
                                        !user.signedBy?.includes(userInfo?.name) &&
                                        !isCompleted
                                        ? 0.5
                                        : 1
                                  }}
                                  onClick={() => handleActionClick(label, user.company)}
                                  disabled={
                                    isCompleted ||
                                    (user.signedBy !== undefined &&
                                      !user.signedBy?.includes(userInfo?.name))
                                  }

                                >
                                  {label}
                                  {/* {isCompleted && date && (
                                    <>
                                      <span> | </span>
                                      <span>
                                        {date.toLocaleDateString("en-GB", {
                                          day: "2-digit",
                                          month: "2-digit",
                                          year: "2-digit"
                                        })}
                                      </span>
                                    </>
                                  )} */}

                                </button>
                              </OverlayTrigger>
                            )
                          })}
                      </td>


                      {/* <td className="flex gap-2">
                        {["Email", "Visit", "Call 1", "Call 2"]
                          .map((label) => {
                            const matchedBook = deliveryBooks.find(book => book.companyName === user.company);

                            const statusMap = {
                              "Email": matchedBook?.isEmail,
                              "Call 1": matchedBook?.isFirstCall,
                              "Call 2": matchedBook?.isSecondCall,
                              "Visit": matchedBook?.isVisit
                            };

                            const dateMap = {
                              "Email": matchedBook?.emailDate,
                              "Call 1": matchedBook?.firstCallDate,
                              "Call 2": matchedBook?.secondCallDate,
                              "Visit": matchedBook?.visitDate
                            };

                            return {
                              label,
                              isCompleted: statusMap[label],
                              date: dateMap[label]
                            };
                          })
                          // ✅ Sort completed items first, then by date (ascending), then incomplete
                          .sort((a, b) => {
                            if (a.isCompleted && b.isCompleted) {
                              return a.date - b.date; // earlier date first
                            }
                            if (a.isCompleted) return -1;
                            if (b.isCompleted) return 1;
                            return 0;
                          })
                          .map(({ label, isCompleted, date }) => (
                            <button
                              key={label}
                              className="px-2 py-1 me-2 border rounded flex items-center gap-1"
                              style={{ backgroundColor: isCompleted ? 'gray' : 'green', color: 'white', width: "140px", opacity: (user.signedBy !== undefined && !user.signedBy?.includes(userInfo?.name)) && !isCompleted ? 0.5 : 1 }}
                              onClick={() => handleActionClick(label, user.company)}
                              disabled={isCompleted || (user.signedBy !== undefined && !user.signedBy?.includes(userInfo?.name))}
                            >
                              {label}
                              {isCompleted && date && (
                                <>
                                  <span> | </span>
                                  <text>
                                    {date &&
                                      new Date(date).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                      })}
                                  </text>
                                </>
                              )}
                            </button>
                          ))}
                      </td> */}
                      {/* <td className="flex gap-2">
                        {["Email", "Call 1", "Call 2", "Visit"].map((label) => {
                          // Match deliveryBook for the company
                          const matchedBook = deliveryBooks.find(book => book.companyName === user.company);
                          // Determine status field based on label
                          const statusMap = {
                            "Email": matchedBook?.isEmail,
                            "Call 1": matchedBook?.isFirstCall,
                            "Call 2": matchedBook?.isSecondCall,
                            "Visit": matchedBook?.isVisit
                          };
                          const dateMap = {
                            "Email": matchedBook?.emailDate,
                            "Call 1": matchedBook?.firstCallDate,
                            "Call 2": matchedBook?.secondCallDate,
                            "Visit": matchedBook?.visitDate
                          };
                          const isCompleted = statusMap[label];

                          return (
                            <button
                              key={label}
                              className={`px-2 py-1 me-2 border rounded flex items-center gap-1`}
                              style={{ backgroundColor: isCompleted ? 'gray' : 'green', color: 'white', width: "140px" }}
                              onClick={() => handleActionClick(label, user.company)}
                              disabled={isCompleted || !userInfo?.isExtSales}
                            >
                              {label}
                              {
                                isCompleted && <>
                                  <span> | </span>
                                  <text>
                                    {dateMap[label] &&
                                      new Date(dateMap[label]).toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "2-digit"
                                      })}
                                  </text>
                                </>
                              }
                            </button>
                          );
                        })}
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </table>
            </Tab>
            <Tab eventKey="PRODUCTS" title="TOP PRODUCTS">
              <table className="table table-striped table-sm">
                <TableHeader
                  headers={topProductsHeaders}
                  widths={topProductsColumnWidths}
                />
                <tbody>
                  {(userInfo.isExtSales === true ? extTopProducts : topSellingProducts).map((order, idx) => (
                    <tr key={idx} >
                      <td className="no-wrap-td">{idx + 1}</td>
                      <td
                        className="no-wrap-td"
                      >
                        {order.user !== null ? (
                          <>
                            {order.name}
                          </>
                        ) : null}
                      </td>
                      <td
                        className="no-wrap-td"
                      >
                        {order.suppliedQty}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Tab>
          </Tabs >
        </Col >
      </Row >
      <Modal show={show} onHide={handleClose} className="order_preview_items">
        <OrderItemForOrderPageComponent id={selectedOrderId} />
      </Modal>
      {
        showCompanyModal && (
          // <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <Modal show={showCompanyModal} onHide={handleClose} className="order_preview_items_sales">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold m-5">ENTER CONTACT DETAILS</h2>
              <table className="m-5">
                <tr>
                  <td>
                    <label className="block text-sm font-medium mb-1">Contact Name</label>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="w-full border px-3 py-2 rounded"
                      value={contactName}
                      onChange={(e) => setContactName(e.target.value)}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <label className="block text-sm font-medium me-1">Contact Email / Phone</label>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="w-full border px-3 py-2 rounded"
                      value={contactInfo}
                      onChange={(e) => setContactInfo(e.target.value)}
                    />
                  </td>
                </tr>
              </table>
              <div className="flex justify-end gap-2 m-5">
                <button
                  className="text-white px-4 py-2 rounded me-2"
                  style={{ backgroundColor: "green" }}
                  onClick={handleCompanyModalSubmit}
                  disabled={!contactName || !contactInfo}
                >
                  Confirm
                </button>
                <button
                  className="text-white px-4 py-2 rounded"
                  style={{ backgroundColor: "blue" }}
                  onClick={() => setShowCompanyModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
        )
      }

      {
        showCustomerModal && (
          // <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <Modal show={showCustomerModal} onHide={handleClose} className="order_preview_items_sales">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold m-5">Contacted Date and Time</h2>
              <table className="m-5">
                <tr>
                  <td>
                    <label className="block text-sm font-medium me-1">
                      Date & Time
                    </label>
                  </td>
                  <td>
                    <input
                      type="datetime-local"
                      className="w-full border px-3 py-2 rounded"
                      // value={formatDateTimeLocal(dateTime)}
                      value={dateTime}
                      onChange={(e) => setDateTime(e.target.value)}
                    />
                  </td>
                </tr>
              </table>
              <div className="flex justify-end gap-2 m-5">
                <button
                  className="text-white px-4 py-2 rounded me-2"
                  style={{ backgroundColor: "green" }}
                  onClick={handleCustomerModelSubmit}
                // disabled={!contactName || !contactInfo}
                >
                  Confirm
                </button>
                <button
                  className="text-white px-4 py-2 rounded"
                  style={{ backgroundColor: "blue" }}
                  onClick={() => setShowCustomerModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
        )
      }
    </>
  );
};

export default SalesOrdersPageComponent;
